module.exports = __webpack_public_path__ + "static/media/pv.8d755472.png";